module.exports = __webpack_public_path__ + "img/figure-6.2a1508cf.png";